import React from 'react';

const STEPS = ['Upload', 'Review', 'Details', 'Success'];

const StepIndicator = ({ currentStep }) => (
    <div className="steps-indicator">
        {STEPS.map((label, i) => {
            const stepNum = i + 1;
            const isCompleted = stepNum < currentStep;
            const isActive = stepNum === currentStep;
            const cls = isCompleted ? 'step completed' : isActive ? 'step active' : 'step';
            return (
                <React.Fragment key={label}>
                    {i > 0 && (
                        <div className={`step-connector${isCompleted || isActive ? ' filled' : ''}`} />
                    )}
                    <div className={cls}>
                        <div className="step-circle">
                            {isCompleted ? (
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                    <path d="M3.5 8.5L6.5 11.5L12.5 4.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            ) : stepNum}
                        </div>
                        <div className="step-title">{label}</div>
                    </div>
                </React.Fragment>
            );
        })}
    </div>
);

export default StepIndicator;
